export default __webpack_public_path__ + "static/media/deanza.5ac1183e.png";